import { render, staticRenderFns } from "./MasterPhoneNumberIndexDetail.vue?vue&type=template&id=babeedc0&scoped=true&"
import script from "./MasterPhoneNumberIndexDetail.vue?vue&type=script&lang=js&"
export * from "./MasterPhoneNumberIndexDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babeedc0",
  null
  
)

export default component.exports